// packages/components/src/showcase/ShowcaseCTA.tsx
import React from 'react';
import { Card, Button } from '@dopomogai/ui';

type CTA = { text: string; onClick: () => void; ariaLabel?: string };

type Props = {
  primary: CTA;            // e.g., Customize & get a quote
  secondary?: CTA;         // e.g., Book a call
  tertiaryInvest?: (CTA & { visible?: boolean }) | null; // e.g., Invest
  className?: string;
};

export function ShowcaseCTA({ primary, secondary, tertiaryInvest, className }: Props) {
  return (
    <Card className={className}>
      <div className="space-y-3">
        <Button
          variant="primary"
          text={primary.text}
          onClick={primary.onClick}
          aria-label={primary.ariaLabel || 'Primary action'}
          fullWidth
          className="!py-3.5"
        />
        {secondary && (
          <Button
            variant="outline"
            text={secondary.text}
            onClick={secondary.onClick}
            aria-label={secondary.ariaLabel || 'Secondary action'}
            fullWidth
          />
        )}
        {tertiaryInvest?.visible && (
          <Button
            variant="secondary"
            text={tertiaryInvest.text}
            onClick={tertiaryInvest.onClick}
            aria-label={tertiaryInvest.ariaLabel || 'Invest'}
            fullWidth
          />
        )}
      </div>
    </Card>
  );
}

export default ShowcaseCTA;
